import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { NAVY, RADIUS_ITEM, SURFACE_CONTAINER_LOWEST } from 'styles/tokens';
import textToReactNodes from 'utils/textToReactNodes';

interface SummaryBoxProps {
  text: string;
}

const SummaryBox: React.FC<SummaryBoxProps> = ({ text }) => {
  return (
    <Box
      sx={{
        backgroundColor: SURFACE_CONTAINER_LOWEST,
        borderRadius: RADIUS_ITEM,
        p: 1.5,
        color: NAVY,
        fontSize: '0.875rem',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      <Typography
        variant="body2"
        component="div"
        sx={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          color: NAVY,
        }}
      >
        {textToReactNodes(text)}
      </Typography>
    </Box>
  );
};

export default SummaryBox;
